import { ICall } from '@/types';
import { getUrl } from '@/utils/api';

const useCallHistory = (contactId: string) => {
  const query = getUrl(`v1/contacts/${contactId}/calls`);
  return {
    ...query,
    data: query.data as ICall[],
  };
};

export default useCallHistory;
